import React from 'react';
import { useTranslation } from 'react-i18next';
import readableFileSize from 'filesize';
import { formatDollars } from '../../../../../utils/formatting';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { getDeviationDownloads } from '../../permissions';
import DownloadOption from './DownloadOption';
var PremiumDownloadOption = function (_a) {
    var deviation = _a.deviation, checked = _a.checked, onSelect = _a.onSelect;
    var t = useTranslation().t;
    // we should just pass the downloads and permissions, but there are some language
    // choices that change if the user is the author or the user is subscribed and
    // we need the deviation for those
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var premiumDownload = getDeviationDownloads({
        deviation: deviation,
        isOwner: isOwner,
    }).premiumDownload;
    if (!premiumDownload) {
        return null;
    }
    // premium pricing in title, filelist in subtitle
    var downloadPrice = premiumDownload.downloadPrice, downloadDollarPrice = premiumDownload.downloadDollarPrice, hasUserPurchased = premiumDownload.hasUserPurchased, assets = premiumDownload.assets, zipFilesize = premiumDownload.zipFilesize;
    var showPriceInPoints = downloadPrice && downloadPrice < 80;
    // show selling language to the owner, buying to others
    var titleKey = isOwner
        ? 'actionbar.download.premium.sellingFor'
        : showPriceInPoints
            ? 'actionbar.download.premium.pointPrice'
            : 'actionbar.download.premium.currencyPrice';
    var titleWithPrice = t(titleKey, {
        price: downloadPrice,
        dollars: formatDollars(downloadDollarPrice),
    });
    // if they've purchased it with cash or via subscription, don't show price
    var pcpOptionTitle = hasUserPurchased
        ? t('actionbar.download.premium.purchased')
        : titleWithPrice;
    if (!isOwner && deviation.tierAccess === 'unlocked') {
        pcpOptionTitle = t('actionbar.download.purchasedThroughSubscription');
    }
    // list the files included in the subtitle
    var fileTypesIncluded = (assets || [])
        .map(function (asset) { return asset.type && asset.type.toLocaleUpperCase(); })
        .filter(function (type, index, array) { return type && array.indexOf(type) === index; })
        .join(' ');
    return (React.createElement(DownloadOption, { value: "premium", checked: checked, title: pcpOptionTitle, subtitle: t('actionbar.download.premium.size', {
            size: readableFileSize(zipFilesize || 0),
            types: fileTypesIncluded,
        }), onSelect: onSelect }));
};
PremiumDownloadOption.displayName = 'PremiumDownloadOption';
export default PremiumDownloadOption;
//# sourceMappingURL=PremiumDownloadOption.js.map